import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AngebotForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telefon: '',
    beschreibung: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('http://localhost:5000/api/angebote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then(() => {
        toast.success('🎉 Angebot erfolgreich eingereicht!', {
          position: 'top-right',
        });
        setFormData({ name: '', email: '', beschreibung: '' });
      })
      .catch(() =>
        toast.error('🚨 Fehler beim Einreichen des Angebots', {
          position: 'top-right',
        })
      );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white px-6 py-20">
      <ToastContainer theme="dark" />
      <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-fuchsia-700">
        <h2 className="text-3xl font-bold mb-8 text-center text-fuchsia-400">Angebot Einholen</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-2 text-sm font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-black border border-gray-700 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
            />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-black border border-gray-700 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
            />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium">Telefon</label>
            <input
              type="tel"
              name="telefon"
              value={formData.telefon}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-black border border-gray-700 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
           
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium">Projektbeschreibung</label>
            <textarea
              name="beschreibung"
              value={formData.beschreibung}
              onChange={handleChange}
              required
              rows="5"
              className="w-full px-4 py-2 rounded-lg bg-black border border-gray-700 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-fuchsia-600 hover:bg-fuchsia-700 text-white font-semibold py-3 rounded-lg transition"
          >
            Angebot Einreichen
          </button>
        </form>
      </div>

      {/* Google Maps */}
      <div className="mt-20 max-w-6xl mx-auto rounded-2xl overflow-hidden shadow-xl border border-gray-700">
        <iframe
          title="Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.969622802084!2d13.404954315958578!3d52.520006979812265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a851e84e4db8c5%3A0x421d5c2fc75d4271!2sBerlin!5e0!3m2!1sen!2sde!4v1614337400000!5m2!1sen!2sde"
          width="100%"
          height="400"
          allowFullScreen=""
          loading="lazy"
          className="w-full h-[400px] border-0"
        ></iframe>
      </div>
    </div>
  );
};

export default AngebotForm;
